/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthActiveChats
 */
export interface TenantHealthActiveChats {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthActiveChats
     */
    total?: number;
}

/**
 * Check if a given object implements the TenantHealthActiveChats interface.
 */
export function instanceOfTenantHealthActiveChats(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthActiveChatsFromJSON(json: any): TenantHealthActiveChats {
    return TenantHealthActiveChatsFromJSONTyped(json, false);
}

export function TenantHealthActiveChatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthActiveChats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function TenantHealthActiveChatsToJSON(value?: TenantHealthActiveChats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
    };
}

